import { BleService } from './ble/bleService';
import { DfuManager } from './ble/dfuManager';
import { inspectBinary } from './ble/binaryValidator';
import { DeviceTelemetry, DfuProgress } from './ble/types';

const ble = new BleService();
const dfu = new DfuManager(ble);

let selectedBinaryBuffer: ArrayBuffer | null = null;

// DOM Elements
const btnThemeToggle = document.getElementById('btnThemeToggle') as HTMLButtonElement;
const themeToggleText = document.getElementById('themeToggleText') as HTMLSpanElement;
const simToggle = document.getElementById('simToggle') as HTMLDivElement;
const connBadge = document.getElementById('connBadge') as HTMLSpanElement;
const btnConnect = document.getElementById('btnConnect') as HTMLButtonElement;
const telemModel = document.getElementById('telemModel') as HTMLDivElement;
const telemSerial = document.getElementById('telemSerial') as HTMLDivElement;
const telemVer = document.getElementById('telemVer') as HTMLDivElement;
const telemBat = document.getElementById('telemBat') as HTMLDivElement;
const telemSignal = document.getElementById('telemSignal') as HTMLDivElement;
const telemSim = document.getElementById('telemSim') as HTMLDivElement;
const telemImei = document.getElementById('telemImei') as HTMLDivElement;
const telemApn = document.getElementById('telemApn') as HTMLDivElement;
const telemNet = document.getElementById('telemNet') as HTMLDivElement;
const telemServerStatus = document.getElementById('telemServerStatus') as HTMLDivElement;
const telemServer = document.getElementById('telemServer') as HTMLDivElement;
const btnRefreshTelem = document.getElementById('btnRefreshTelem') as HTMLButtonElement;

const telemDir = document.getElementById('telemDir') as HTMLDivElement;
const telemTime = document.getElementById('telemTime') as HTMLDivElement;
const telemWorkSlot = document.getElementById('telemWorkSlot') as HTMLDivElement;
const telemStorCyc = document.getElementById('telemStorCyc') as HTMLDivElement;
const telemUpCyc = document.getElementById('telemUpCyc') as HTMLDivElement;
const telemSimId = document.getElementById('telemSimId') as HTMLDivElement;

const metricCountIn = document.getElementById('metricCountIn') as HTMLDivElement;
const metricCountOut = document.getElementById('metricCountOut') as HTMLDivElement;
const btnToggleLiveStream = document.getElementById('btnToggleLiveStream') as HTMLButtonElement;
const liveStreamText = document.getElementById('liveStreamText') as HTMLSpanElement;
const footfallLiveBadge = document.getElementById('footfallLiveBadge') as HTMLSpanElement;
const btnResetCounts = document.getElementById('btnResetCounts') as HTMLButtonElement;
const resetCountsText = document.getElementById('resetCountsText') as HTMLSpanElement;

const btnTestCellular = document.getElementById('btnTestCellular') as HTMLButtonElement;
const btnRebootSensor = document.getElementById('btnRebootSensor') as HTMLButtonElement;

// FV801 Omni Counting & Magnetic Sensitivity Elements
const metricCardIn = document.getElementById('metricCardIn') as HTMLDivElement;
const metricCardOut = document.getElementById('metricCardOut') as HTMLDivElement;
const metricCardOmni = document.getElementById('metricCardOmni') as HTMLDivElement;
const metricCountOmni = document.getElementById('metricCountOmni') as HTMLDivElement;

const cfgMagSection = document.getElementById('cfgMagSection') as HTMLDivElement;
const magIntervalSlider = document.getElementById('magIntervalSlider') as HTMLInputElement;
const magIntervalValue = document.getElementById('magIntervalValue') as HTMLSpanElement;
const magIntervalSeconds = document.getElementById('magIntervalSeconds') as HTMLSpanElement;
const magSensitivityBadge = document.getElementById('magSensitivityBadge') as HTMLSpanElement;
const btnSaveMagInterval = document.getElementById('btnSaveMagInterval') as HTMLButtonElement;

const simModelWrap = document.getElementById('simModelWrap') as HTMLDivElement;
const simModelText = document.getElementById('simModelText') as HTMLSpanElement;
const btnSimModelToggle = document.getElementById('btnSimModelToggle') as HTMLButtonElement;

// Cellular Diagnostic Pipeline Elements
const cellularDiagPipeline = document.getElementById('cellularDiagPipeline') as HTMLDivElement;
const pipelineOverallStatus = document.getElementById('pipelineOverallStatus') as HTMLSpanElement;
const btnCollapseCellularDiag = document.getElementById('btnCollapseCellularDiag') as HTMLButtonElement;
const cellularBtNotice = document.getElementById('cellularBtNotice') as HTMLDivElement;
const cellularBtNoticeText = document.getElementById('cellularBtNoticeText') as HTMLSpanElement;
const btnReconnectFromCellularDiag = document.getElementById('btnReconnectFromCellularDiag') as HTMLButtonElement;

const stepModemPower = document.getElementById('stepModemPower') as HTMLDivElement;
const stepIcon1 = document.getElementById('stepIcon1') as HTMLSpanElement;
const stepDesc1 = document.getElementById('stepDesc1') as HTMLDivElement;

const stepCellAttach = document.getElementById('stepCellAttach') as HTMLDivElement;
const stepIcon2 = document.getElementById('stepIcon2') as HTMLSpanElement;
const stepDesc2 = document.getElementById('stepDesc2') as HTMLDivElement;

const stepHttpInit = document.getElementById('stepHttpInit') as HTMLDivElement;
const stepIcon3 = document.getElementById('stepIcon3') as HTMLSpanElement;
const stepDesc3 = document.getElementById('stepDesc3') as HTMLDivElement;

const stepDataUpload = document.getElementById('stepDataUpload') as HTMLDivElement;
const stepIcon4 = document.getElementById('stepIcon4') as HTMLSpanElement;
const stepDesc4 = document.getElementById('stepDesc4') as HTMLDivElement;

const stepFlightMode = document.getElementById('stepFlightMode') as HTMLDivElement;
const stepIcon5 = document.getElementById('stepIcon5') as HTMLSpanElement;
const stepDesc5 = document.getElementById('stepDesc5') as HTMLDivElement;

// Custom Confirmation Modal Elements
const confirmModal = document.getElementById('confirmModal') as HTMLDivElement;
const modalTitle = document.getElementById('modalTitle') as HTMLDivElement;
const modalMsg = document.getElementById('modalMsg') as HTMLDivElement;
const modalBtnCancel = document.getElementById('modalBtnCancel') as HTMLButtonElement;
const modalBtnConfirm = document.getElementById('modalBtnConfirm') as HTMLButtonElement;
const modalIconWrap = document.getElementById('modalIconWrap') as HTMLDivElement;

// Unexpected Disconnect Modal Elements
const lostConnModal = document.getElementById('lostConnModal') as HTMLDivElement;
const btnDismissLostConn = document.getElementById('btnDismissLostConn') as HTMLButtonElement;
const btnReconnectLostConn = document.getElementById('btnReconnectLostConn') as HTMLButtonElement;

const dropzone = document.getElementById('dropzone') as HTMLDivElement;
const fileInput = document.getElementById('fileInput') as HTMLInputElement;
const binInfo = document.getElementById('binInfo') as HTMLDivElement;
const binSize = document.getElementById('binSize') as HTMLSpanElement;
const binModel = document.getElementById('binModel') as HTMLSpanElement;
const binSP = document.getElementById('binSP') as HTMLSpanElement;
const binReset = document.getElementById('binReset') as HTMLSpanElement;

const progressArea = document.getElementById('progressArea') as HTMLDivElement;
const progressBar = document.getElementById('progressBar') as HTMLDivElement;
const progressStatus = document.getElementById('progressStatus') as HTMLSpanElement;
const progressPercent = document.getElementById('progressPercent') as HTMLSpanElement;
const progressSpeed = document.getElementById('progressSpeed') as HTMLSpanElement;
const progressEta = document.getElementById('progressEta') as HTMLSpanElement;

const flashActionArea = document.getElementById('flashActionArea') as HTMLDivElement;
const btnFlash = document.getElementById('btnFlash') as HTMLButtonElement;
const btnAbort = document.getElementById('btnAbort') as HTMLButtonElement;
const flasherBadge = document.getElementById('flasherBadge') as HTMLSpanElement;

const cfgApn = document.getElementById('cfgApn') as HTMLInputElement;
const cfgApnUser = document.getElementById('cfgApnUser') as HTMLInputElement;
const cfgApnPass = document.getElementById('cfgApnPass') as HTMLInputElement;
const btnSaveApn = document.getElementById('btnSaveApn') as HTMLButtonElement;

const cfgHost = document.getElementById('cfgHost') as HTMLInputElement;
const cfgPort = document.getElementById('cfgPort') as HTMLInputElement;
const cfgApi = document.getElementById('cfgApi') as HTMLInputElement;
const btnSaveConfig = document.getElementById('btnSaveConfig') as HTMLButtonElement;
const btnPresetVengoCloud = document.getElementById('btnPresetVengoCloud') as HTMLButtonElement | null;

const terminalLogs = document.getElementById('terminalLogs') as HTMLDivElement;
const btnCopyLogs = document.getElementById('btnCopyLogs') as HTMLButtonElement;
const btnClearLogs = document.getElementById('btnClearLogs') as HTMLButtonElement;

const chkScanAll = document.getElementById('chkScanAll') as HTMLInputElement;
const btnFlushDevices = document.getElementById('btnFlushDevices') as HTMLButtonElement;

const reconnectBanner = document.getElementById('reconnectBanner') as HTMLDivElement;
const btnDismissReconnectBanner = document.getElementById('btnDismissReconnectBanner') as HTMLButtonElement;
const btnReconnectVerify = document.getElementById('btnReconnectVerify') as HTMLButtonElement;
const updateToast = document.getElementById('updateToast') as HTMLDivElement;
const btnReloadApp = document.getElementById('btnReloadApp') as HTMLButtonElement;
const btnCheckUpdate = document.getElementById('btnCheckUpdate') as HTMLButtonElement;

let imeiPollTimer1: number | null = null;
let imeiPollTimer2: number | null = null;

function clearImeiPollTimers() {
  if (imeiPollTimer1 !== null) {
    window.clearTimeout(imeiPollTimer1);
    imeiPollTimer1 = null;
  }
  if (imeiPollTimer2 !== null) {
    window.clearTimeout(imeiPollTimer2);
    imeiPollTimer2 = null;
  }
}

function scheduleImeiAutoPoll() {
  clearImeiPollTimers();
  imeiPollTimer1 = window.setTimeout(() => {
    if (ble.isConnected() && (!telemImei.textContent || telemImei.innerHTML.includes('pulsing-text'))) {
      addLog('Cellular modem booting up. Querying telemetry for assigned IMEI & SIM...', 'info');
      ble.requestDeviceInfo().catch(() => {});
    }
  }, 10000);

  imeiPollTimer2 = window.setTimeout(() => {
    if (ble.isConnected() && (!telemImei.textContent || telemImei.innerHTML.includes('pulsing-text'))) {
      addLog('Checking modem IMEI & cellular registration status...', 'info');
      ble.requestDeviceInfo().catch(() => {});
    }
  }, 22000);
}

function formatDeviceTime(raw: string): string {
  const clean = raw.trim();
  if (clean.length === 12) {
    const y = `20${clean.slice(0, 2)}`;
    const m = clean.slice(2, 4);
    const d = clean.slice(4, 6);
    const hh = clean.slice(6, 8);
    const mm = clean.slice(8, 10);
    const ss = clean.slice(10, 12);
    return `<span class="time-date">${y}-${m}-${d}</span><span class="time-clock">${hh}:${mm}:${ss}</span>`;
  }
  if (clean.length === 14) {
    const y = clean.slice(0, 4);
    const m = clean.slice(4, 6);
    const d = clean.slice(6, 8);
    const hh = clean.slice(8, 10);
    const mm = clean.slice(10, 12);
    const ss = clean.slice(12, 14);
    return `<span class="time-date">${y}-${m}-${d}</span><span class="time-clock">${hh}:${mm}:${ss}</span>`;
  }
  return escapeHtml(clean) || '--';
}

function formatSimIccid(raw: string): string {
  const clean = raw.trim();
  // Standard SIM ICCIDs reported by modems (via AT+CCID or JSON) are 20 digits,
  // where the 20th digit is the Luhn check/parity digit. Physical SIM cards
  // (such as 1NCE) only print the first 19 digits.
  if (clean.length === 20) {
    return clean.slice(0, 19);
  }
  return clean;
}

function flashButtonSuccess(btn: HTMLButtonElement, successText: string, durationMs = 2500, onComplete?: () => void) {
  const origHtml = btn.innerHTML;
  const origClass = btn.className;
  const cleanText = successText.replace(/^[✓✔]\s*/, '');
  btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> <span>${escapeHtml(cleanText)}</span>`;
  btn.style.background = 'var(--emerald-accent)';
  btn.style.borderColor = 'var(--emerald-accent)';
  btn.style.color = '#064e3b';
  setTimeout(() => {
    btn.className = origClass;
    btn.style.background = '';
    btn.style.borderColor = '';
    btn.style.color = '';
    if (onComplete) {
      onComplete();
    } else {
      btn.innerHTML = origHtml;
    }
    if (ble.isConnected()) {
      btn.disabled = false;
    }
  }, durationMs);
}

function addLog(msg: string, type: 'info' | 'warn' | 'error' | 'success' = 'info') {
  const entry = document.createElement('div');
  entry.className = `log-entry ${type}`;
  const now = new Date();
  const timeStr = now.toTimeString().split(' ')[0] + '.' + String(now.getMilliseconds()).padStart(3, '0');
  entry.innerHTML = `<span class="log-time">[${timeStr}]</span>${escapeHtml(msg)}`;
  terminalLogs.appendChild(entry);
  terminalLogs.scrollTop = terminalLogs.scrollHeight;
}

function escapeHtml(str: string): string {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

// Modal System Helper
interface ConfirmModalOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isDanger?: boolean;
}

let activeModalResolve: ((val: boolean) => void) | null = null;

function showConfirmModal(opts: ConfirmModalOptions): Promise<boolean> {
  return new Promise((resolve) => {
    if (activeModalResolve) {
      activeModalResolve(false);
    }
    activeModalResolve = resolve;

    modalTitle.textContent = opts.title;
    modalMsg.innerHTML = opts.message;
    modalBtnConfirm.textContent = opts.confirmText || 'Confirm';

    if (opts.cancelText === '') {
      modalBtnCancel.style.display = 'none';
    } else {
      modalBtnCancel.style.display = 'block';
      modalBtnCancel.textContent = opts.cancelText || 'Cancel';
    }

    if (opts.isDanger) {
      modalBtnConfirm.className = 'btn btn-danger';
      modalIconWrap.className = 'modal-icon-wrap warn';
    } else {
      modalBtnConfirm.className = 'btn btn-primary';
      modalIconWrap.className = 'modal-icon-wrap info';
    }

    confirmModal.style.display = 'flex';
  });
}

modalBtnConfirm?.addEventListener('click', () => {
  confirmModal.style.display = 'none';
  if (activeModalResolve) {
    activeModalResolve(true);
    activeModalResolve = null;
  }
});

modalBtnCancel?.addEventListener('click', () => {
  confirmModal.style.display = 'none';
  if (activeModalResolve) {
    activeModalResolve(false);
    activeModalResolve = null;
  }
});

btnDismissLostConn?.addEventListener('click', () => {
  lostConnModal.style.display = 'none';
});

btnReconnectLostConn?.addEventListener('click', async () => {
  lostConnModal.style.display = 'none';
  addLog('Attempting to reconnect to sensor...', 'info');
  btnConnect.disabled = true;
  btnConnect.textContent = 'Connecting...';
  try {
    const telem = await ble.reconnect();
    updateUiConnected(telem);
    addLog(`Sensor successfully reconnected! Firmware: ${telem.firmwareVersion}`, 'success');
  } catch (err) {
    updateUiDisconnected();
    addLog(`Reconnect failed: ${(err as Error).message}. Verify sensor button was pressed for 2 seconds.`, 'warn');
  } finally {
    btnConnect.disabled = false;
  }
});

// Continuous Live Footfall Counting
let liveStreamInterval: number | null = null;
let isLiveStreamActive = false;
let currentInCount = 0;
let currentOutCount = 0;
let isWipeFlashing = false;

function updateResetCountsButton() {
  if (isWipeFlashing) return;
  const total = currentInCount + currentOutCount;
  if (resetCountsText) {
    resetCountsText.textContent = `Wipe Counts (${total})`;
  }
}

// FV801 Magnetic Sensitivity Ruler Helpers
let magSaveTimer: number | null = null;
let magBtnResetTimer: number | null = null;

function setMagSaveButtonState(
  state: 'idle' | 'modifying' | 'saving' | 'saved' | 'read' | 'error',
  val?: number
) {
  if (!btnSaveMagInterval) return;
  if (magBtnResetTimer !== null) {
    window.clearTimeout(magBtnResetTimer);
    magBtnResetTimer = null;
  }

  const ms = val !== undefined ? val : (Number(magIntervalSlider.value) || 1000);

  if (state === 'idle') {
    btnSaveMagInterval.className = 'btn btn-secondary';
    btnSaveMagInterval.innerHTML = `
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
      <span>Save Sensitivity</span>
    `;
    btnSaveMagInterval.disabled = !ble.isConnected();
  } else if (state === 'modifying') {
    btnSaveMagInterval.className = 'btn btn-secondary';
    btnSaveMagInterval.innerHTML = `
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spinning"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
      <span>Auto-saving (${ms}ms)...</span>
    `;
    btnSaveMagInterval.disabled = false;
  } else if (state === 'saving') {
    btnSaveMagInterval.className = 'btn btn-secondary';
    btnSaveMagInterval.innerHTML = `
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spinning"><circle cx="12" cy="12" r="10"/><path d="M12 2a10 10 0 0 1 10 10"/></svg>
      <span>Writing (${ms}ms)...</span>
    `;
    btnSaveMagInterval.disabled = true;
  } else if (state === 'saved') {
    btnSaveMagInterval.className = 'btn btn-emerald';
    btnSaveMagInterval.innerHTML = `
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
      <span>Saved (${ms}ms)</span>
    `;
    btnSaveMagInterval.disabled = false;
    magBtnResetTimer = window.setTimeout(() => {
      setMagSaveButtonState('idle');
    }, 2500);
  } else if (state === 'read') {
    btnSaveMagInterval.className = 'btn btn-secondary';
    btnSaveMagInterval.innerHTML = `
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="color: var(--cyan-primary);"><polyline points="20 6 9 17 4 12"/></svg>
      <span style="color: var(--cyan-primary);">Synchronized (${ms}ms)</span>
    `;
    btnSaveMagInterval.disabled = false;
    magBtnResetTimer = window.setTimeout(() => {
      setMagSaveButtonState('idle');
    }, 2500);
  } else if (state === 'error') {
    btnSaveMagInterval.className = 'btn btn-danger';
    btnSaveMagInterval.innerHTML = `
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
      <span>Save Failed</span>
    `;
    btnSaveMagInterval.disabled = false;
  }
}

function getSensitivityLabel(val: number): { label: string; className: string } {
  if (val <= 400) {
    return { label: 'Ultra Sensitive', className: 'status-badge flashing' };
  } else if (val <= 750) {
    return { label: 'Sensitive (Bikes)', className: 'status-badge connected' };
  } else if (val <= 1500) {
    return { label: 'Standard', className: 'status-badge connected' };
  } else {
    return { label: 'Filtered (Vehicles)', className: 'status-badge disconnected' };
  }
}

function applyMagIntervalDisplay(val: number) {
  if (magIntervalSlider) magIntervalSlider.value = String(val);
  if (magIntervalValue) magIntervalValue.textContent = String(val);
  if (magIntervalSeconds) magIntervalSeconds.textContent = (val / 1000).toFixed(1);
  if (magSensitivityBadge) {
    const { label, className } = getSensitivityLabel(val);
    magSensitivityBadge.textContent = label;
    magSensitivityBadge.className = className;
  }
}

async function saveMagInterval(val: number) {
  if (!ble.isConnected()) return;
  setMagSaveButtonState('saving', val);

  try {
    await ble.setMagCountInterval(val);
    setMagSaveButtonState('saved', val);
    addLog(`FV801 magnetic refractory window saved: ${val}ms (${(val / 1000).toFixed(1)}s)`, 'success');
  } catch (err) {
    setMagSaveButtonState('error', val);
    addLog(`Failed to write countInterval: ${(err as Error).message}`, 'error');
  }
}

function handleMagIntervalInput(val: number) {
  applyMagIntervalDisplay(val);
  if (!ble.isConnected()) return;
  if (magSaveTimer !== null) {
    window.clearTimeout(magSaveTimer);
  }
  setMagSaveButtonState('modifying', val);
  magSaveTimer = window.setTimeout(() => {
    saveMagInterval(val);
  }, 600);
}

function startLiveStream() {
  if (liveStreamInterval !== null) return;
  isLiveStreamActive = true;
  btnToggleLiveStream.classList.add('btn-emerald');
  btnToggleLiveStream.classList.remove('btn-secondary');
  liveStreamText.textContent = 'Live Polling: Active';
  if (footfallLiveBadge) footfallLiveBadge.style.display = 'inline-flex';
  addLog('Live footfall continuous polling activated (1.5s interval).', 'info');

  // Trigger immediate query upon activation
  ble.requestCurrentData().catch(() => {});

  liveStreamInterval = window.setInterval(async () => {
    if (!ble.isConnected() || dfu.isFlashing || isCellularTestRunning) return;
    try {
      await ble.requestCurrentData();
    } catch {
      // Ignore background transient timeout
    }
  }, 1500);
}

function stopLiveStream() {
  if (liveStreamInterval !== null) {
    clearInterval(liveStreamInterval);
    liveStreamInterval = null;
  }
  isLiveStreamActive = false;
  btnToggleLiveStream.classList.remove('btn-emerald');
  btnToggleLiveStream.classList.add('btn-secondary');
  liveStreamText.textContent = 'Start Live Polling';
  if (footfallLiveBadge) footfallLiveBadge.style.display = 'none';
}

btnToggleLiveStream?.addEventListener('click', () => {
  if (!ble.isConnected()) {
    addLog('Connect a sensor before enabling live footfall streaming.', 'warn');
    return;
  }
  if (isLiveStreamActive) {
    stopLiveStream();
    addLog('Live footfall continuous polling stopped.', 'info');
  } else {
    startLiveStream();
  }
});

// Cellular Diagnostic Pipeline Helpers
let isCellularTestRunning = false;
let cellularSafetyTimeout: number | null = null;

function setDiagStep(
  stepEl: HTMLElement,
  iconEl: HTMLElement,
  descEl: HTMLElement,
  state: 'pending' | 'active' | 'done' | 'error',
  text?: string
) {
  stepEl.className = `diag-step ${state}`;
  if (state === 'pending') {
    iconEl.textContent = '⏳';
  } else if (state === 'active') {
    iconEl.textContent = '⚡';
  } else if (state === 'done') {
    iconEl.textContent = '✓';
  } else if (state === 'error') {
    iconEl.textContent = '✕';
  }
  if (text) {
    descEl.textContent = text;
  }
}

function resetCellularDiagnostic(visible = false) {
  if (cellularSafetyTimeout !== null) {
    clearTimeout(cellularSafetyTimeout);
    cellularSafetyTimeout = null;
  }
  isCellularTestRunning = false;
  btnTestCellular.disabled = !ble.isConnected();
  btnTestCellular.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg> <span>Test Cellular Upload</span>`;

  if (!visible) {
    cellularDiagPipeline.classList.add('sliding-up');
    setTimeout(() => {
      cellularDiagPipeline.style.display = 'none';
      cellularDiagPipeline.classList.remove('sliding-up');
    }, 220);
  } else {
    if (cellularBtNotice) cellularBtNotice.style.display = 'none';
    cellularDiagPipeline.classList.remove('sliding-up');
    cellularDiagPipeline.style.display = 'flex';
    pipelineOverallStatus.className = 'status-badge flashing';
    pipelineOverallStatus.textContent = 'Testing...';
    pipelineOverallStatus.style.color = '';
    setDiagStep(stepModemPower, stepIcon1, stepDesc1, 'pending', 'Baseband boot');
    setDiagStep(stepCellAttach, stepIcon2, stepDesc2, 'pending', 'CEREG & Signal');
    setDiagStep(stepHttpInit, stepIcon3, stepDesc3, 'pending', 'HTTP Handshake');
    setDiagStep(stepDataUpload, stepIcon4, stepDesc4, 'pending', 'Payload upload');
    setDiagStep(stepFlightMode, stepIcon5, stepDesc5, 'pending', 'Flight mode off');
  }
}

btnCollapseCellularDiag?.addEventListener('click', () => {
  cellularDiagPipeline.classList.add('sliding-up');
  setTimeout(() => {
    cellularDiagPipeline.style.display = 'none';
    cellularDiagPipeline.classList.remove('sliding-up');
  }, 220);
});

btnReconnectFromCellularDiag?.addEventListener('click', async () => {
  if (cellularBtNotice) cellularBtNotice.style.display = 'none';
  addLog('Attempting to reconnect to sensor after cellular upload...', 'info');
  btnConnect.disabled = true;
  btnConnect.textContent = 'Connecting...';
  try {
    const telem = await ble.reconnect();
    updateUiConnected(telem);
    addLog(`Sensor successfully reconnected! Firmware: ${telem.firmwareVersion}`, 'success');
  } catch (err) {
    updateUiDisconnected();
    addLog(`Reconnect failed: ${(err as Error).message}. Verify sensor button was pressed (2s).`, 'warn');
  } finally {
    btnConnect.disabled = false;
  }
});

function handleCellularLogEvent(line: string) {
  if (!isCellularTestRunning) return;

  // Step 1: Baseband boot & CSQ
  if (line.includes('+CSQ:') || line.includes('Turn on the network module') || line.includes('AT+CEREG?')) {
    setDiagStep(stepModemPower, stepIcon1, stepDesc1, 'done', 'Powered (CSQ OK)');
    setDiagStep(stepCellAttach, stepIcon2, stepDesc2, 'active', 'Attaching LTE...');
  }

  // Step 2: CEREG registration & LTE Attach
  if (line.includes('+CEREG: 0,1') || line.includes('+CEREG: 0,5') || line.includes('AT+HTTPINIT')) {
    setDiagStep(stepCellAttach, stepIcon2, stepDesc2, 'done', 'LTE Attached');
    setDiagStep(stepHttpInit, stepIcon3, stepDesc3, 'active', 'HTTP Init...');
  }

  // Step 3: HTTP Init & Config URL
  if (line.includes('AT+HTTPDATA') || line.includes('DOWNLOAD') || line.includes('SEND_DATA')) {
    setDiagStep(stepHttpInit, stepIcon3, stepDesc3, 'done', 'URL & Headers OK');
    setDiagStep(stepDataUpload, stepIcon4, stepDesc4, 'active', 'Sending payload...');
  }

  // Step 4: HTTPACTION Ingestion Result
  if (line.includes('+HTTPACTION: 1,200') || line.includes('+HTTPACTION: 1,20')) {
    setDiagStep(stepDataUpload, stepIcon4, stepDesc4, 'done', 'HTTP 200 OK');
    setDiagStep(stepFlightMode, stepIcon5, stepDesc5, 'active', 'Entering flight...');
  } else if (
    line.includes('+HTTPACTION: 1,4') ||
    line.includes('+HTTPACTION: 1,5') ||
    line.includes('+HTTPACTION: 1,60')
  ) {
    setDiagStep(stepDataUpload, stepIcon4, stepDesc4, 'error', 'Upload failed');
    pipelineOverallStatus.className = 'status-badge disconnected';
    pipelineOverallStatus.textContent = 'Upload HTTP Error';
  }

  // Step 5: Flight Mode / Power Down - Restore button IMMEDIATELY without delay
  if (line.includes('Flight mode!') || line.includes('CAT1 Power off')) {
    setDiagStep(stepFlightMode, stepIcon5, stepDesc5, 'done', 'Flight mode off');
    pipelineOverallStatus.className = 'status-badge connected';
    pipelineOverallStatus.textContent = 'Success (HTTP 200)';
    pipelineOverallStatus.style.color = 'var(--emerald-light)';
    addLog('Cellular test completed successfully! Modem powered down.', 'success');

    if (cellularSafetyTimeout !== null) {
      clearTimeout(cellularSafetyTimeout);
      cellularSafetyTimeout = null;
    }
    isCellularTestRunning = false;
    btnTestCellular.disabled = !ble.isConnected();
    btnTestCellular.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> <span>Tested OK</span>`;
    setTimeout(() => {
      if (!isCellularTestRunning && ble.isConnected()) {
        btnTestCellular.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg> <span>Test Cellular Upload</span>`;
      }
    }, 4000);
  }
}

// Setup BLE Callbacks
ble.setCallbacks({
  onLog: (msg, type) => addLog(msg, type),
  onDisconnect: () => {
    stopLiveStream();
    if (ble.isRebootingAfterFlash) {
      ble.isRebootingAfterFlash = false;
      connBadge.className = 'status-badge disconnected';
      connBadge.textContent = 'Rebooting...';
      btnConnect.textContent = 'Scan & Connect Sensor';
      btnConnect.classList.remove('btn-secondary');
      reconnectBanner.style.display = 'flex';
      addLog('Sensor rebooted to apply firmware. 100% delivered! Ready to verify.', 'success');
      return;
    }

    if (isCellularTestRunning) {
      // Sensor MCU firmware temporarily suspended Bluetooth during cellular radio transmission
      addLog('Sensor temporarily paused Bluetooth radio during high-power cellular upload.', 'warn');
      setDiagStep(stepDataUpload, stepIcon4, stepDesc4, 'active', 'LTE upload in progress (BT paused)...');
      pipelineOverallStatus.className = 'status-badge flashing';
      pipelineOverallStatus.textContent = 'Transmitting (BT Paused)';

      if (cellularBtNotice) {
        cellularBtNotice.style.display = 'flex';
        cellularBtNoticeText.textContent = 'Modem transmitting over LTE. Sensor paused Bluetooth radio.';
      }
      updateUiDisconnected();
      return; // Do NOT throw disruptive lostConnModal
    }

    if (!ble.isUserDisconnecting && !ble.isRebootingSensor) {
      updateUiDisconnected();
      reconnectBanner.style.display = 'none';
      lostConnModal.style.display = 'flex';
      addLog('Bluetooth link lost unexpectedly. Sensor may have timed out or moved out of range.', 'warn');
      return;
    }

    updateUiDisconnected();
    reconnectBanner.style.display = 'none';
    addLog('Device disconnected', 'warn');
  },
  onNotify: (_bytes, text) => {
    addLog(`RX <- ${text.trim()}`, 'info');
    handleCellularLogEvent(text);
  }
});

// JSON stream listener for parsed protocol objects
ble.addJsonListener((obj) => {
  if (obj.ver) {
    telemVer.textContent = String(obj.ver);
  }
  if (obj.id) {
    telemSerial.textContent = String(obj.id);
  }
  if (obj.model) {
    telemModel.textContent = String(obj.model);
  }
  if (obj.Bat !== undefined) {
    telemBat.textContent = `${obj.Bat}%`;
  }
  if (obj.rssi !== undefined) {
    telemSignal.textContent = `${obj.rssi} dBm`;
  }
  if (obj.SIM !== undefined) {
    telemSim.textContent = obj.SIM ? 'Inserted (OK)' : 'Missing';
  }
  if (obj.SIMID !== undefined) {
    const simStr = String(obj.SIMID).trim();
    if (simStr) telemSimId.textContent = formatSimIccid(simStr);
  }
  if (obj.IMEI !== undefined) {
    const imeiStr = String(obj.IMEI).trim();
    if (imeiStr.length > 3) {
      telemImei.textContent = imeiStr;
      clearImeiPollTimers();
    }
  }
  if (obj.time !== undefined) {
    telemTime.innerHTML = formatDeviceTime(String(obj.time));
  }
  if (obj.storCyc !== undefined) {
    telemStorCyc.textContent = `${obj.storCyc} min`;
  }
  if (obj.upCyc !== undefined) {
    const upM = Number(obj.upCyc);
    telemUpCyc.textContent = upM % 60 === 0 ? `${upM} min (${upM / 60}h)` : `${upM} min`;
  }
  if (obj.open !== undefined && obj.close !== undefined) {
    const op = String(obj.open).padStart(4, '0');
    const cl = String(obj.close).padStart(4, '0');
    telemWorkSlot.textContent = `${op.slice(0, 2)}:${op.slice(2)} - ${cl.slice(0, 2)}:${cl.slice(2)}`;
  }
  if (obj.dir !== undefined) {
    const dirMap: Record<string, string> = {
      twoWay: 'Two-Way (IN / OUT)',
      onlyIn: 'Only IN',
      onlyOut: 'Only OUT',
      exchange: 'Swapped (Opposite)',
      total: 'Total Pass'
    };
    telemDir.textContent = dirMap[String(obj.dir)] || String(obj.dir);
  }
  if (obj.apn !== undefined) {
    telemApn.textContent = String(obj.apn || 'None');
    if (obj.apn) cfgApn.value = String(obj.apn);
  }
  if (obj.apnN !== undefined) {
    cfgApnUser.value = String(obj.apnN);
  }
  if (obj.apnP !== undefined) {
    cfgApnPass.value = String(obj.apnP);
  }
  if (obj.addr && obj.port) {
    telemServer.textContent = `${obj.addr}:${obj.port}${obj.api || ''}`;
    cfgHost.value = String(obj.addr);
    cfgPort.value = String(obj.port);
    if (obj.api) cfgApi.value = String(obj.api);
  }
  if (obj.netS !== undefined) {
    telemNet.textContent = obj.netS ? 'Connected (OK)' : 'Network Error';
    telemNet.style.color = obj.netS ? 'var(--emerald-light)' : '#f87171';
  }
  if (obj.serverS !== undefined) {
    const s = String(obj.serverS);
    telemServerStatus.textContent = s === 'onLine' ? 'Online (Reporting)' : s === 'offLine' ? 'Offline' : 'Error';
    telemServerStatus.style.color = s === 'onLine' ? 'var(--emerald-light)' : '#f87171';
  }
  function updateMetricValueWithBump(el: HTMLElement, newVal: string) {
    if (el.textContent !== newVal) {
      el.textContent = newVal;
      el.classList.remove('value-bump');
      void el.offsetWidth;
      el.classList.add('value-bump');
      setTimeout(() => el.classList.remove('value-bump'), 250);
    }
  }

  if (obj.in !== undefined) {
    currentInCount = Number(obj.in) || 0;
    updateMetricValueWithBump(metricCountIn, String(obj.in));
    updateResetCountsButton();
  }
  if (obj.out !== undefined) {
    currentOutCount = Number(obj.out) || 0;
    updateMetricValueWithBump(metricCountOut, String(obj.out));
    updateResetCountsButton();
  }
  if (obj.total !== undefined) {
    currentInCount = Number(obj.total) || 0;
    currentOutCount = 0;
    if (metricCountOmni) {
      updateMetricValueWithBump(metricCountOmni, String(obj.total));
    }
    // Automatically reveal omni card if not visible
    if (metricCardOmni && metricCardOmni.style.display === 'none') {
      metricCardOmni.style.display = 'flex';
      if (metricCardIn) metricCardIn.style.display = 'none';
      if (metricCardOut) metricCardOut.style.display = 'none';
      if (cfgMagSection) cfgMagSection.style.display = 'flex';
    }
    updateResetCountsButton();
  }
  if (obj.countInterval !== undefined) {
    const val = Number(obj.countInterval);
    if (!isNaN(val) && val > 0) {
      applyMagIntervalDisplay(val);
      setMagSaveButtonState('read', val);
    }
  }
  if (obj.clearDay === '1') {
    currentInCount = 0;
    currentOutCount = 0;
    metricCountIn.textContent = '0';
    metricCountOut.textContent = '0';
    if (metricCountOmni) metricCountOmni.textContent = '0';
    isWipeFlashing = true;
    flashButtonSuccess(btnResetCounts, 'Counts Wiped (0)', 2000, () => {
      isWipeFlashing = false;
      updateResetCountsButton();
      btnResetCounts.disabled = !ble.isConnected();
    });
    addLog('Passage counters successfully reset to zero on device.', 'success');
  }
  if (obj.restart === '1') {
    addLog('Sensor confirmed hardware restart command. Rebooting MCU...', 'warn');
  }
});

// Setup DFU Callbacks
dfu.setProgressCallback((p: DfuProgress) => {
  progressArea.style.display = 'flex';
  progressBar.style.width = `${p.percent}%`;
  progressPercent.textContent = `${p.percent}%`;
  progressStatus.textContent = p.message;

  if (p.speedBps > 0) {
    progressSpeed.textContent = `${(p.speedBps / 1024).toFixed(1)} KB/s`;
    progressEta.textContent = `ETA: ${p.etaSeconds}s`;
  }

  if (p.stage === 'ERROR') {
    flasherBadge.className = 'status-badge disconnected';
    flasherBadge.textContent = 'Error';
    btnFlash.disabled = false;
    btnAbort.style.display = 'none';
    addLog(`Flash Error: ${p.error || p.message}`, 'error');
  } else if (p.stage === 'COMPLETED') {
    flasherBadge.className = 'status-badge connected';
    flasherBadge.textContent = '100%';
    btnFlash.disabled = false;
    btnAbort.style.display = 'none';
    if (flashActionArea) flashActionArea.style.display = 'none';
    if (reconnectBanner) reconnectBanner.style.display = 'flex';
    addLog('DFU update successfully finished! Bootloader is applying the update.', 'success');
  } else if (p.stage === 'STREAMING' || p.stage === 'HANDSHAKE') {
    if (reconnectBanner) reconnectBanner.style.display = 'none';
    if (flashActionArea) flashActionArea.style.display = 'flex';
    flasherBadge.className = 'status-badge flashing';
    flasherBadge.textContent = `${p.percent}%`;
    btnFlash.disabled = true;
    btnAbort.style.display = 'inline-block';
  }
});

function resetFlashConfirmationBox() {
  if (reconnectBanner) reconnectBanner.style.display = 'none';
  if (progressArea) progressArea.style.display = 'none';
  if (flashActionArea) flashActionArea.style.display = 'flex';
  if (flasherBadge) {
    flasherBadge.className = 'status-badge disconnected';
    flasherBadge.textContent = 'Ready';
  }
  ble.isRebootingAfterFlash = false;
}

function updateUiConnected(t: DeviceTelemetry) {
  resetFlashConfirmationBox();
  connBadge.className = 'status-badge connected';
  connBadge.textContent = ble.mockMode ? 'Simulated' : 'Connected';
  btnConnect.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/></svg> Disconnect`;
  btnConnect.classList.remove('btn-secondary');
  btnConnect.classList.add('btn-danger');

  if (btnRefreshTelem) btnRefreshTelem.style.display = 'inline-flex';

  telemModel.textContent = t.model;
  telemSerial.textContent = t.serialNumber;
  telemVer.textContent = t.firmwareVersion;
  telemBat.textContent = t.batteryPercent ? `${t.batteryPercent}%` : '--';
  telemDir.textContent = t.direction || '--';
  telemTime.innerHTML = t.deviceTime ? formatDeviceTime(t.deviceTime) : '--';
  telemWorkSlot.textContent = t.workingSlot || '--';
  telemStorCyc.textContent = t.storageCycleMin ? `${t.storageCycleMin} min` : '--';
  telemUpCyc.textContent = t.uploadCycleMin ? `${t.uploadCycleMin} min` : '--';
  telemSignal.textContent = t.rssi !== undefined ? `${t.rssi} dBm` : '--';
  telemSim.textContent = t.simInserted !== undefined ? (t.simInserted ? 'Inserted (OK)' : 'Missing') : '--';
  
  if (t.simId && t.simId.length > 3) {
    telemSimId.textContent = formatSimIccid(t.simId);
  } else {
    telemSimId.innerHTML = '<span class="pulsing-text">Reading SIM...</span>';
  }

  if (t.imei && t.imei.length > 3) {
    telemImei.textContent = t.imei;
  } else {
    telemImei.innerHTML = '<span class="pulsing-text">Reading modem (booting)...</span>';
    scheduleImeiAutoPoll();
  }

  telemApn.textContent = t.apn || '--';
  telemNet.textContent = t.netConnected !== undefined ? (t.netConnected ? 'Connected (OK)' : 'Network Error') : '--';
  telemServerStatus.textContent = t.serverStatus ? (t.serverStatus === 'onLine' ? 'Online (Reporting)' : t.serverStatus) : '--';
  telemServer.textContent = t.serverHost ? `${t.serverHost}:${t.serverPort}${t.serverApi}` : '--';

  if (t.serverHost) cfgHost.value = t.serverHost;
  if (t.serverPort) cfgPort.value = String(t.serverPort);
  if (t.serverApi) cfgApi.value = t.serverApi;

  if (t.apn) cfgApn.value = t.apn;
  if (t.apnUser) cfgApnUser.value = t.apnUser;
  if (t.apnPass) cfgApnPass.value = t.apnPass;

  btnSaveConfig.disabled = false;
  btnSaveApn.disabled = false;
  btnToggleLiveStream.disabled = false;
  btnResetCounts.disabled = false;
  btnTestCellular.disabled = false;
  btnRebootSensor.disabled = false;

  // Toggle Between Two-Way (FP102) and Omni-Directional Passages (FV801)
  const isFv801 = (t.model && t.model.toUpperCase().includes('FV801')) || t.direction === 'total';
  if (isFv801) {
    if (metricCardIn) metricCardIn.style.display = 'none';
    if (metricCardOut) metricCardOut.style.display = 'none';
    if (metricCardOmni) metricCardOmni.style.display = 'flex';
    if (cfgMagSection) cfgMagSection.style.display = 'flex';
  } else {
    if (metricCardIn) metricCardIn.style.display = 'flex';
    if (metricCardOut) metricCardOut.style.display = 'flex';
    if (metricCardOmni) metricCardOmni.style.display = 'none';
    if (cfgMagSection) cfgMagSection.style.display = 'none';
  }

  // Auto read-out of FV801 magnetic trigger refractory window
  if (t.countInterval !== undefined && t.countInterval > 0) {
    applyMagIntervalDisplay(t.countInterval);
  }
  if (t.totalCount !== undefined && metricCountOmni) {
    metricCountOmni.textContent = String(t.totalCount);
    currentInCount = t.totalCount;
    currentOutCount = 0;
    updateResetCountsButton();
  }
  if (btnSaveMagInterval) btnSaveMagInterval.disabled = false;

  validateFlashButton();
}

function updateUiDisconnected() {
  clearImeiPollTimers();
  stopLiveStream();
  resetCellularDiagnostic(false);
  resetFlashConfirmationBox();
  connBadge.className = 'status-badge disconnected';
  connBadge.textContent = 'Disconnected';
  btnConnect.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m7 7 10 10-5 5V2l5 5L7 17"/></svg> Scan &amp; Connect Sensor`;
  btnConnect.classList.remove('btn-danger');
  btnConnect.classList.remove('btn-secondary');

  if (btnRefreshTelem) btnRefreshTelem.style.display = 'none';

  telemModel.textContent = '--';
  telemSerial.textContent = '--';
  telemVer.textContent = '--';
  telemBat.textContent = '--';
  telemDir.textContent = '--';
  telemTime.innerHTML = '--';
  telemWorkSlot.textContent = '--';
  telemStorCyc.textContent = '--';
  telemUpCyc.textContent = '--';
  telemSignal.textContent = '--';
  telemSim.textContent = '--';
  telemSimId.textContent = '--';
  telemImei.textContent = '--';
  telemApn.textContent = '--';
  telemNet.textContent = '--';
  telemNet.style.color = '';
  telemServerStatus.textContent = '--';
  telemServerStatus.style.color = '';
  telemServer.textContent = '--';

  metricCountIn.textContent = '--';
  metricCountOut.textContent = '--';
  if (metricCountOmni) metricCountOmni.textContent = '--';
  if (metricCardIn) metricCardIn.style.display = 'flex';
  if (metricCardOut) metricCardOut.style.display = 'flex';
  if (metricCardOmni) metricCardOmni.style.display = 'none';
  if (cfgMagSection) cfgMagSection.style.display = 'none';
  if (btnSaveMagInterval) btnSaveMagInterval.disabled = true;
  setMagSaveButtonState('idle');
  currentInCount = 0;
  currentOutCount = 0;
  isWipeFlashing = false;
  if (resetCountsText) {
    resetCountsText.textContent = 'Wipe Counts (0)';
  }

  btnSaveConfig.disabled = true;
  btnSaveApn.disabled = true;
  btnToggleLiveStream.disabled = true;
  btnResetCounts.disabled = true;
  btnTestCellular.disabled = true;
  btnRebootSensor.disabled = true;
  validateFlashButton();
}

btnRefreshTelem?.addEventListener('click', async () => {
  if (!ble.isConnected()) return;
  addLog('Refreshing device telemetry (info: get)...', 'info');
  btnRefreshTelem.disabled = true;
  btnRefreshTelem.classList.add('spinning');
  try {
    await ble.requestDeviceInfo();
  } catch (err) {
    addLog(`Telemetry refresh failed: ${(err as Error).message}`, 'warn');
  } finally {
    setTimeout(() => {
      btnRefreshTelem.disabled = false;
      btnRefreshTelem.classList.remove('spinning');
    }, 600);
  }
});

function validateFlashButton() {
  const canFlash = ble.isConnected() && selectedBinaryBuffer !== null;
  btnFlash.disabled = !canFlash;
}

// Sim Toggle
simToggle.addEventListener('click', () => {
  if (ble.isConnected()) {
    ble.disconnect();
  }
  ble.mockMode = !ble.mockMode;
  simToggle.classList.toggle('active', ble.mockMode);
  if (simModelWrap) {
    simModelWrap.style.display = ble.mockMode ? 'inline-flex' : 'none';
  }
  if (simModelText) {
    simModelText.textContent = `${ble.mockDevice.model} (${ble.mockDevice.model === 'FV801' ? 'MAG' : 'PIR'})`;
  }
  addLog(
    ble.mockMode
      ? `Hardware Simulator ENABLED (Model: ${ble.mockDevice.model}). Click 'Scan & Connect Sensor' to test offline!`
      : 'Hardware Simulator DISABLED. Using real Web Bluetooth radio.',
    'info'
  );
});

// Simulator Sensor Model Toggle (FP102 PIR vs FV801 MAG)
btnSimModelToggle?.addEventListener('click', () => {
  const currentModel = ble.mockDevice.model;
  const nextModel = currentModel === 'FV801' ? 'FP102' : 'FV801';
  ble.mockDevice.setModel(nextModel);
  if (simModelText) {
    simModelText.textContent = `${nextModel} (${nextModel === 'FV801' ? 'MAG' : 'PIR'})`;
  }
  addLog(
    `Hardware Simulator switched to: ${nextModel} (${nextModel === 'FV801' ? 'Magnetic Omni-Directional' : 'Infrared Two-Way'})`,
    'info'
  );
  if (ble.isConnected()) {
    ble.requestDeviceInfo().catch(() => {});
  }
});

// Checkbox Scan All Toggle (Default is ALWAYS false / strict filtering enabled)
ble.scanAll = false;
localStorage.removeItem('vengosense_scan_all');
if (chkScanAll) {
  chkScanAll.checked = false;
}
chkScanAll?.addEventListener('change', () => {
  ble.scanAll = chkScanAll.checked;
  addLog(
    ble.scanAll
      ? 'Scan Mode: Showing all nearby Bluetooth devices (filter disabled).'
      : 'Filtered Mode: Scanning exclusively for FP102 & FV801 sensors (unknown devices filtered out).',
    'info'
  );
});

// Clear & Reload Button (Performs complete cache purge + SW unregister + hard reload)
btnFlushDevices?.addEventListener('click', async () => {
  btnFlushDevices.disabled = true;
  btnFlushDevices.textContent = '⏳ Clearing...';
  addLog('Purging Bluetooth state, clearing Service Worker storage, and resetting browser cache...', 'info');

  try {
    await ble.forgetKnownDevices();
  } catch {}

  // 1. Delete all Service Worker CacheStorage entries
  if ('caches' in window) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    } catch {}
  }

  // 2. Unregister all service workers so next load fetches fresh from network
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const reg of registrations) {
        await reg.unregister();
      }
    } catch {}
  }

  // 3. Clear local storage scan flags and session storage
  localStorage.removeItem('vengosense_scan_all');
  sessionStorage.clear();

  addLog('Cache purged! Hard reloading page...', 'success');

  // 4. Force a hard reload bypassing all HTTP cache with timestamp
  const cleanUrl = window.location.origin + window.location.pathname + '?clean=' + Date.now();
  window.location.replace(cleanUrl);
});

// Connect / Disconnect Button
btnConnect.addEventListener('click', async () => {
  if (ble.isConnected()) {
    addLog('Disconnecting sensor...', 'info');
    resetFlashConfirmationBox();
    await ble.disconnect();
    updateUiDisconnected();
    addLog('Sensor disconnected successfully', 'info');
    return;
  }

  // Strictly synchronize and pass checkbox DOM state directly to scanAndConnect
  const shouldScanAll = chkScanAll ? chkScanAll.checked : false;
  ble.scanAll = shouldScanAll;

  resetFlashConfirmationBox();
  try {
    const telem = await ble.scanAndConnect(shouldScanAll);
    updateUiConnected(telem);
  } catch (err: unknown) {
    updateUiDisconnected();
    const errMsg = (err as Error).message || '';
    if (errMsg.includes('User cancelled') || (err as Error).name === 'NotFoundError') {
      addLog(
        'Bluetooth chooser closed without selection. Tip: If the list was empty, 1) Check Mac System Settings > Privacy & Security > Bluetooth, 2) Verify sensor button is pressed (2s), or 3) Check "Show all nearby Bluetooth devices" to confirm your Mac Bluetooth is scanning.',
        'warn'
      );
    } else {
      addLog(`Connection error: ${errMsg}`, 'error');
    }
  }
});

// File Dropzone Handling
dropzone.addEventListener('click', () => fileInput.click());
dropzone.addEventListener('dragover', (e) => {
  e.preventDefault();
  dropzone.classList.add('dragover');
});
dropzone.addEventListener('dragleave', () => dropzone.classList.remove('dragover'));
dropzone.addEventListener('drop', (e) => {
  e.preventDefault();
  dropzone.classList.remove('dragover');
  if (e.dataTransfer && e.dataTransfer.files.length > 0) {
    handleFile(e.dataTransfer.files[0]);
  }
});

fileInput.addEventListener('change', () => {
  if (fileInput.files && fileInput.files.length > 0) {
    handleFile(fileInput.files[0]);
  }
});

function handleFile(file: File) {
  if (!file.name.endsWith('.bin')) {
    addLog(`Warning: "${file.name}" does not have a .bin extension.`, 'warn');
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    const buffer = e.target?.result as ArrayBuffer;
    if (!buffer) return;

    selectedBinaryBuffer = buffer;
    if (reconnectBanner) reconnectBanner.style.display = 'none';
    if (flashActionArea) flashActionArea.style.display = 'flex';
    const info = inspectBinary(buffer);

    binInfo.style.display = 'flex';
    binSize.textContent = `${(info.sizeBytes / 1024).toFixed(1)} KB (${info.sizeBytes} B)`;
    binModel.textContent = info.modelDetected + (info.versionGuess ? ` (${info.versionGuess})` : '');
    binSP.textContent = `0x${info.initialSP.toString(16).toUpperCase()}`;
    binReset.textContent = `0x${info.resetHandler.toString(16).toUpperCase()}`;

    if (!info.valid) {
      addLog(`Binary validation failed: ${info.error}`, 'error');
      btnFlash.disabled = true;
    } else {
      addLog(
        `Binary valid for STM32 Cortex-M0+ (Model: ${info.modelDetected}, SP: 0x${info.initialSP.toString(16)}, Reset: 0x${info.resetHandler.toString(16)})`,
        'success'
      );
      validateFlashButton();
    }
  };
  reader.readAsArrayBuffer(file);
}

// Flash Button
btnFlash.addEventListener('click', async () => {
  if (!selectedBinaryBuffer || !ble.isConnected()) return;

  const ok = await showConfirmModal({
    title: 'Flash Firmware to Sensor?',
    message: `Ready to upload firmware binary over Bluetooth BLE.<br><br><b>Size:</b> ${(selectedBinaryBuffer.byteLength / 1024).toFixed(1)} KB (${selectedBinaryBuffer.byteLength} bytes)<br><b>Target:</b> STM32 Internal Flash (0x08005000)<br><br>Ensure the sensor remains in Bluetooth range and do not turn off power during flashing.`,
    confirmText: 'Start Flashing',
    isDanger: false
  });
  if (!ok) return;

  try {
    await dfu.flashFirmware(selectedBinaryBuffer);
  } catch (err: unknown) {
    addLog(`Flash aborted or failed: ${(err as Error).message}`, 'error');
  }
});

// Abort Button
btnAbort.addEventListener('click', () => {
  dfu.abort();
  addLog('User aborted flashing', 'warn');
});

// Save APN Config Button
btnSaveApn.addEventListener('click', async () => {
  const apn = cfgApn.value.trim();
  const apnN = cfgApnUser.value.trim();
  const apnP = cfgApnPass.value.trim();

  if (!apn) {
    addLog('Please enter a valid APN name', 'warn');
    return;
  }

  try {
    addLog(`Setting device APN to "${apn}" (User: "${apnN || 'none'}")...`, 'info');
    await ble.configureApn({ apn, apnN, apnP });
    telemApn.textContent = apn;
    flashButtonSuccess(btnSaveApn, 'APN Saved!');
    addLog('APN configuration command delivered to device!', 'success');
  } catch (err: unknown) {
    addLog(`Failed to send APN config: ${(err as Error).message}`, 'error');
  }
});

// Preset: vengoCLOUD auto-fill (iot.vengo.cloud:80/api/V1/dataUpload)
btnPresetVengoCloud?.addEventListener('click', () => {
  cfgHost.value = 'iot.vengo.cloud';
  cfgPort.value = '80';
  cfgApi.value = '/api/V1/dataUpload';
  addLog('Applied vengoCLOUD preset: iot.vengo.cloud:80/api/V1/dataUpload', 'info');

  [cfgHost, cfgPort, cfgApi].forEach((input) => {
    input.classList.add('input-preset-flash');
    setTimeout(() => input.classList.remove('input-preset-flash'), 600);
  });
});

// Save Server Config Button
btnSaveConfig.addEventListener('click', async () => {
  const host = cfgHost.value.trim();
  const port = parseInt(cfgPort.value.trim(), 10);
  const api = cfgApi.value.trim();

  if (!host || isNaN(port)) {
    addLog('Please enter valid host and port', 'warn');
    return;
  }

  try {
    addLog(`Updating device server configuration to ${host}:${port}${api}...`, 'info');
    await ble.configureServer({ addr: host, port, api });
    flashButtonSuccess(btnSaveConfig, 'Server Saved!');
    addLog('Server configuration command sent successfully!', 'success');
  } catch (err: unknown) {
    addLog(`Failed to send server config: ${(err as Error).message}`, 'error');
  }
});

// FV801 Magnetic Sensitivity Ruler Listeners
magIntervalSlider?.addEventListener('input', () => {
  const val = Number(magIntervalSlider.value);
  handleMagIntervalInput(val);
});

document.querySelectorAll<HTMLButtonElement>('.ruler-preset-btn').forEach((btn) => {
  btn.addEventListener('click', () => {
    const val = Number(btn.getAttribute('data-val'));
    if (!isNaN(val) && val > 0) {
      handleMagIntervalInput(val);
    }
  });
});

btnSaveMagInterval?.addEventListener('click', () => {
  if (magSaveTimer !== null) {
    window.clearTimeout(magSaveTimer);
    magSaveTimer = null;
  }
  const val = Number(magIntervalSlider.value) || 1000;
  saveMagInterval(val);
});

// Passage Counter Wipe Counts Button
btnResetCounts?.addEventListener('click', async () => {
  if (!ble.isConnected()) return;
  const total = currentInCount + currentOutCount;
  const isOmni = metricCardOmni && metricCardOmni.style.display !== 'none';
  const msg = isOmni
    ? `Are you sure you want to reset total passage count (${total}) to zero?<br><br>This will clear the ${total} recorded passage${total === 1 ? '' : 's'} stored in sensor memory.`
    : `Are you sure you want to reset IN (${currentInCount}) and OUT (${currentOutCount}) counts to zero?<br><br>This will clear the ${total} daily passage${total === 1 ? '' : 's'} stored in sensor memory.`;

  const ok = await showConfirmModal({
    title: 'Reset Passage Counters?',
    message: msg,
    confirmText: `Wipe Counts (${total})`,
    isDanger: true
  });
  if (!ok) return;

  btnResetCounts.disabled = true;
  try {
    await ble.clearDayData();
  } catch (err) {
    addLog(`Failed to wipe counters: ${(err as Error).message}`, 'error');
  } finally {
    if (!isWipeFlashing) {
      btnResetCounts.disabled = !ble.isConnected();
    }
  }
});

// Test Cellular Connection & Upload Button
btnTestCellular?.addEventListener('click', async () => {
  if (!ble.isConnected()) return;
  addLog('Initiating Cellular Connection & Ingestion Diagnostic Test...', 'info');
  addLog('Powering on CAT1 cellular modem and enabling live trace stream...', 'info');

  resetCellularDiagnostic(true);
  isCellularTestRunning = true;
  btnTestCellular.disabled = true;
  btnTestCellular.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spinning"><circle cx="12" cy="12" r="10"/><path d="M12 2a10 10 0 0 1 10 10"/></svg> <span>Testing Cellular...</span>`;
  setDiagStep(stepModemPower, stepIcon1, stepDesc1, 'active', 'Booting baseband...');

  // Fallback safety timeout (40s max in case modem fails to reply or attach)
  cellularSafetyTimeout = window.setTimeout(() => {
    if (isCellularTestRunning) {
      isCellularTestRunning = false;
      btnTestCellular.disabled = !ble.isConnected();
      btnTestCellular.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg> <span>Test Cellular Upload</span>`;
      pipelineOverallStatus.className = 'status-badge disconnected';
      pipelineOverallStatus.textContent = 'Timed Out';
      addLog('Cellular test reached safety timeout without modem power down confirmation.', 'warn');
    }
  }, 40000);

  try {
    await ble.testCellularConnection();
    addLog('Modem test started! Live AT commands and HTTP status will stream below.', 'success');
  } catch (err) {
    addLog(`Failed to start cellular test: ${(err as Error).message}`, 'error');
    resetCellularDiagnostic(false);
  }
});

// Remote Reboot Sensor Button
btnRebootSensor?.addEventListener('click', async () => {
  if (!ble.isConnected()) return;
  const ok = await showConfirmModal({
    title: 'Reboot Sensor?',
    message: 'Reboot sensor now?<br><br>The Bluetooth connection will close and the sensor MCU will perform a hardware restart.',
    confirmText: 'Reboot Sensor',
    isDanger: true
  });
  if (!ok) return;

  btnRebootSensor.disabled = true;
  try {
    await ble.rebootDevice();
    addLog('Hardware reboot command sent to sensor. Device is restarting.', 'warn');
  } catch (err) {
    addLog(`Failed to send reboot command: ${(err as Error).message}`, 'error');
    btnRebootSensor.disabled = !ble.isConnected();
  }
});

// Copy Logs to Clipboard
btnCopyLogs?.addEventListener('click', async () => {
  const logEntries = Array.from(terminalLogs.querySelectorAll('.log-entry'))
    .map((el) => (el as HTMLElement).innerText.trim())
    .filter(Boolean);
  const text = logEntries.length > 0 ? logEntries.join('\n') : terminalLogs.innerText.trim();

  if (!text) {
    addLog('No logs to copy.', 'warn');
    return;
  }

  try {
    await navigator.clipboard.writeText(text);
    const originalHtml = btnCopyLogs.innerHTML;
    btnCopyLogs.innerHTML = `✓ Copied!`;
    setTimeout(() => {
      btnCopyLogs.innerHTML = originalHtml;
    }, 2000);
  } catch (err) {
    addLog(`Failed to copy logs to clipboard: ${(err as Error).message}`, 'warn');
  }
});

// Clear Logs
btnClearLogs.addEventListener('click', () => {
  terminalLogs.innerHTML = '';
});

// Dismiss Flash Reconnect Confirmation Banner
btnDismissReconnectBanner?.addEventListener('click', () => {
  resetFlashConfirmationBox();
});

// Reconnect & Verify Button
btnReconnectVerify.addEventListener('click', async () => {
  btnReconnectVerify.disabled = true;
  btnReconnectVerify.textContent = 'Connecting to sensor...';
  try {
    addLog('Connecting to sensor to verify newly flashed firmware...', 'info');
    const telem = await ble.reconnect();
    resetFlashConfirmationBox();
    updateUiConnected(telem);
    addLog(`Verification Success! Active firmware version: ${telem.firmwareVersion}`, 'success');
  } catch (err: unknown) {
    addLog(`Could not reconnect yet: ${(err as Error).message}. Ensure you pressed the button for 2s!`, 'warn');
  } finally {
    btnReconnectVerify.disabled = false;
    btnReconnectVerify.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/></svg> Sensor Button Pressed &bull; Reconnect &amp; Verify`;
  }
});

// Service Worker Update & Refresh Handling
let swRegistration: ServiceWorkerRegistration | null = null;

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then((reg) => {
      swRegistration = reg;

      // Check if update is waiting
      if (reg.waiting) {
        updateToast.style.display = 'flex';
      }

      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            updateToast.style.display = 'flex';
          }
        });
      });
    })
    .catch(() => {});

  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

btnReloadApp?.addEventListener('click', () => {
  if (swRegistration && swRegistration.waiting) {
    swRegistration.waiting.postMessage('SKIP_WAITING');
  } else {
    window.location.reload();
  }
});

btnCheckUpdate?.addEventListener('click', async () => {
  addLog('Checking for updates...', 'info');
  if (swRegistration) {
    try {
      await swRegistration.update();
      if (swRegistration.waiting) {
        updateToast.style.display = 'flex';
      } else {
        addLog('Checking network for latest release...', 'info');
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
        window.location.reload();
      }
    } catch {
      window.location.reload();
    }
  } else {
    window.location.reload();
  }
});

// ==========================================================================
// Theme Switcher & System Color Preference Sync
// ==========================================================================
const THEME_STORAGE_KEY = 'vengosense_theme';

function getStoredTheme(): 'light' | 'dark' | null {
  const saved = localStorage.getItem(THEME_STORAGE_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return null;
}

function getSystemTheme(): 'light' | 'dark' {
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
    return 'light';
  }
  return 'dark';
}

function applyTheme(theme: 'light' | 'dark') {
  document.documentElement.setAttribute('data-theme', theme);
  const metaTheme = document.querySelector('meta[name="theme-color"]');
  if (metaTheme) {
    metaTheme.setAttribute('content', theme === 'light' ? '#f8fafc' : '#0a0d14');
  }
  if (themeToggleText) {
    themeToggleText.textContent = theme === 'light' ? 'Light' : 'Dark';
  }
}

// Initialize theme on app boot
const initialTheme = getStoredTheme() || getSystemTheme();
applyTheme(initialTheme);

// Toggle button click listener
btnThemeToggle?.addEventListener('click', () => {
  const active = document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  const next = active === 'light' ? 'dark' : 'light';
  localStorage.setItem(THEME_STORAGE_KEY, next);
  applyTheme(next);
  addLog(`Theme switched to ${next.toUpperCase()} mode.`, 'info');
});

// Sync dynamically with OS color scheme changes if user has not set an explicit override
if (window.matchMedia) {
  window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', (e) => {
    if (!getStoredTheme()) {
      applyTheme(e.matches ? 'light' : 'dark');
    }
  });
}

